export default __webpack_public_path__ + "static/vertical-logo-white-56b24a760847a3eee10184f8fe8ec0dc.svg";